export const config = {
  // TODO Implemetar valores reales
  auth: {
    clientId: '2f510617-0105-42a4-84cb-e4d5e5597e97',
    authority: `https://login.microsoftonline.com/fbf70b36-9f4a-4882-a409-cf8365dee9e5`,
    redirectUri: '/register',
    postLogoutRedirectUri: '/login',
    navigateToLoginRequestUrl: false
  },
  cache: {
    cacheLocation: 'sessionStorage', // This configures where your cache will be stored
    storeAuthStateInCookie: true // Set this to "true" if you are having issues on IE11 or Edge
  }
};

export const loginRequest = {
  scopes: [`profile openid email User.Read`]
};
